import React from 'react';
import { Inline } from '@styleseat/ui';
import { BrandColor } from '@styleseat/brand';
import analytics from '../../../../modules/analytics';
import { AuthOrigins } from '../../../../modules/user/constants';
import { Button, HeaderText } from '../../../ui';
import { useLinkTo, useIsMobile } from '../../../../hooks';
import { PROVIDER_ONBOARDING_SIGNUP } from '../../../../route-names';

type ListMyBusinessBannerProps = {
  origin?: AuthOrigins;
  onClick?: () => void;
};

export const ListMyBusinessBanner: React.FCWithChildren<ListMyBusinessBannerProps> = ({ origin, onClick }) => {
  const linkTo = useLinkTo();
  const isMobile = useIsMobile();

  const handleGrowBusinessClick = () => {
    analytics.track('list-my-business-banner__grow-your-business-button-clicked');

    if (onClick) {
      onClick();
    }

    linkTo(PROVIDER_ONBOARDING_SIGNUP, {
      source: origin,
    });
  };

  return (
    <Inline
      color={BrandColor.BoneLight}
      padding={16}
      justifyContent="space-between"
      alignItems="center"
      borderRadiusBottom={isMobile ? 0 : 8}
    >
      <HeaderText level={4}>Grow your business with StyleSeat</HeaderText>
      <Button
        size="small"
        appearance="primary-neue"
        style={{
          padding: '0 8px',
        }}
        onClick={handleGrowBusinessClick}
      >
        List my business
      </Button>
    </Inline>
  );
};
